export default __webpack_public_path__ + "static/media/your_role_xl.4a9f375e.jpg";